import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import DepartmentEvaluation from "../../../domains/DepartmentEvaluation/DepartmentEvaluation";
import DepartmentEvaluationForm from "../../../domains/DepartmentEvaluation/DepartmentEvaluationForm";

const SLICE_NAME = "departmentEvaluations";

interface DepartmentEvaluationState {
  departmentEvaluations: Array<DepartmentEvaluation>
  isEvaluationsDrawerOpen: boolean
  isEvaluationsFormOpen: boolean
  departmentEvaluationsFormData: DepartmentEvaluationForm | null
  isSubmittingForm: boolean
  hasErrorSubmittingForm: boolean
  submitFormSuccess: boolean
  isLoadingEvaluationStatuses: boolean
  hasErrorLoadingStatuses: boolean
  evaluationStatuses: Array<string>
}

const initialState: DepartmentEvaluationState = {
  departmentEvaluations: [],
  isEvaluationsDrawerOpen: false,
  isEvaluationsFormOpen: false,
  departmentEvaluationsFormData: null,
  isSubmittingForm: false,
  hasErrorSubmittingForm: false,
  submitFormSuccess: false,
  isLoadingEvaluationStatuses: false,
  hasErrorLoadingStatuses: false,
  evaluationStatuses: []
};

export const departmentEvaluationsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setDepartmentEvaluations: (state, action: PayloadAction<Array<DepartmentEvaluation>>) => {
      state.departmentEvaluations = action.payload;
    },
    openEvaluationsDrawer: (state) => {
      state.isEvaluationsDrawerOpen = true;
    },
    closeEvaluationsDrawer: (state) => {
      state.isEvaluationsDrawerOpen = false;
    },
    openEvaluationForm: (state) => {
      state.isEvaluationsFormOpen = true;
    },
    closeEvaluationForm: (state) => {
      state.isEvaluationsFormOpen = false;
    },
    submitEvaluationForm: (state) => {
      state.isSubmittingForm = true;
    },
    submitFormSuccess: (state) => {
      state.isSubmittingForm = false;
      state.submitFormSuccess = true;
    },
    submitFormError: (state) => {
      state.isSubmittingForm = false;
      state.hasErrorSubmittingForm = true;
    },
    fetchStatuses: (state) => {
      state.isLoadingEvaluationStatuses = true;
    },
    fetchStatusesSuccess: (state, action: PayloadAction<string[]>) => {
      state.isLoadingEvaluationStatuses = false;
      state.evaluationStatuses = action.payload;
    },
    fetchStatusesError: (state) => {
      state.isLoadingEvaluationStatuses = false;
      state.hasErrorLoadingStatuses = true;
    },
    resetFormStatus: (state) => {
      state.submitFormSuccess = false;
      state.isSubmittingForm = false;
      state.hasErrorSubmittingForm = false;
    }
  }
});

export const {
  setDepartmentEvaluations,
  openEvaluationsDrawer,
  closeEvaluationsDrawer,
  openEvaluationForm,
  closeEvaluationForm,
  fetchStatuses,
  fetchStatusesSuccess,
  fetchStatusesError,
  submitEvaluationForm,
  submitFormError,
  submitFormSuccess,
  resetFormStatus
} = departmentEvaluationsSlice.actions;

export default departmentEvaluationsSlice.reducer;
